var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharedVideo = function SvgSharedVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122 -634)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 59",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(122 634)",
    fill: "#e34d59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1127",
    d: "M137.979 661.157a4.982 4.982 0 1 1 3.524-1.457 4.982 4.982 0 0 1-3.524 1.457Zm0-8.147a3.166 3.166 0 1 0 2.241.926 3.166 3.166 0 0 0-2.241-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1128",
    d: "M150.45 653.969a4.984 4.984 0 1 1 3.523-8.508 4.984 4.984 0 0 1-3.523 8.508Zm0-8.151a3.167 3.167 0 1 0 2.241.927 3.167 3.167 0 0 0-2.241-.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1129",
    d: "M150.445 668.342a4.984 4.984 0 1 1 4.984-4.984 4.984 4.984 0 0 1-4.984 4.984Zm0-8.151a3.167 3.167 0 1 0 3.167 3.167 3.167 3.167 0 0 0-3.167-3.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1130",
    d: "M141.511 655.045a.909.909 0 0 1-.455-1.7l5.406-3.116a.91.91 0 1 1 .909 1.575l-5.406 3.116a.908.908 0 0 1-.454.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1131",
    d: "M146.917 662.232a.908.908 0 0 1-.453-.121l-5.407-3.116a.91.91 0 1 1 .909-1.575l5.406 3.116a.909.909 0 0 1-.454 1.7Z"
  })))));
};
export default SvgSharedVideo;